import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import akhiratLogo from "../../assets/images/akhirat-logo.png";
import { getBrand } from "../../utils/brand";

function Footer() {
  const { t } = useTranslation();
  const brand = getBrand();

  return (
    <footer>
      <div className="footer-top py-6 md:py-10 px-6 md:px-16">
        <div className="flex justify-center md:justify-start">
          <img
            src={akhiratLogo}
            alt="Akhirat"
            loading="lazy"
            decoding="async"
            className="md:h-[68px]"
          />
        </div>
        <div className="flex flex-col md:flex-row flex-wrap pt-8">
          <div className="w-full md:w-1/4 mb-7 md:mb-0 md:pr-12">
            <div className="h-full">
              <div className="mb-2 pb-3 text-2xl font-[CormorantGaramond] font-bold border-b-1 border-[#725C41]">
                {brand.shortName}
              </div>
              <div className="text-[15px]">
                Honoring Islamic traditions <br />
                with dignity and respect <br />
                in funeral services coordination.
              </div>
            </div>
          </div>
          <div className="w-full md:w-1/4 mb-7 md:mb-0 md:pr-12">
            <div className="h-full flex flex-col">
              <div className="mb-2 pb-3 text-2xl font-[CormorantGaramond] font-bold border-b-1 border-[#725C41]">
                Services
              </div>
              <Link className="text-[15px] mb-2">
                Ambulance Transport
              </Link>
              <Link className="text-[15px] mb-2">
                Religious Rites
              </Link>
              <Link className="text-[15px] mb-2">
                Document Management
              </Link>
              <Link className="text-[15px]">
                Payment Processing
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/4 mb-7 md:mb-0 md:pr-12">
            <div className="h-full flex flex-col">
              <div className="mb-2 pb-3 text-2xl font-[CormorantGaramond] font-bold border-b-1 border-[#725C41]">
                {t("footer.support.title")}
              </div>
              <Link className="text-[15px] mb-2">
                {t("footer.support.familyGuidance")}
              </Link>
              <Link className="text-[15px] mb-2">
                {t("footer.support.educationalResources")}
              </Link>
              <Link className="text-[15px] mb-2">
                {t("footer.support.providerNetwork")}
              </Link>
              <Link to="/faq" className="text-[15px]">
                {t("footer.support.faq")}
              </Link>
            </div>
          </div>
          <div className="w-full md:w-1/4">
            <div className="h-full flex flex-col">
              <div className="mb-2 text-2xl font-[CormorantGaramond] font-bold pb-3 border-b-1 border-[#725C41]">
                Contact
              </div>
              <a href="mailto:support@akhirat.co" className="text-[15px] mb-3">
                support@akhirat.co
              </a>
              <div className="text-[15px]">
                Kuala Lumpur, Malaysia
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer text-white text-center py-3 px-6">
        <div className="text-xs uppercase">
          🇲🇾 Designed for Malaysian Muslim families | Compliant with Islamic funeral traditions
        </div>
        <div className="pt-1 md:pt-2 text-xs uppercase">
          © {new Date().getFullYear()} {brand.name}. All rights reserved.
        </div>
        <div className="pt-2 flex items-center justify-center gap-4 text-xs">
          <Link to="/privacy-policy" className="underline hover:text-[#D4AF37]">
            Privacy Policy
          </Link>
          <span aria-hidden>·</span>
          <Link to="/terms-of-service" className="underline hover:text-[#D4AF37]">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
